import React from "react";
import CalendlyTextWidget from "./CalendlyTextWidget";

const services = [
  {
    title: "In-Person Reiki and Chakra Balancing",
    price: "$90",
    duration: "60 minutes",
    description: `
      Reiki is a calming and personalized experience designed to support your well-being. We’ll begin by discussing what you’re hoping to focus on during the session. 

      You’ll then lie down fully clothed in a cozy and peaceful environment with soft music and soothing scents to create a relaxing atmosphere. The session starts with me tuning into your energy by hovering my hands above your body or, with your permission, gently placing my hands on areas like your shoulders, knees, or feet.

      Reiki works by channeling energy to encourage deep relaxation and release tension or energy blockages, allowing your body’s natural healing abilities to take over. Afterward, you’re welcome to share your experience. 

      Many people feel warmth, tingling, or a deep sense of peace. It’s a beautiful way to reconnect with yourself and feel recharged.
    `,
  },
  {
    title: "Distance Reiki",
    price: "$60",
    duration: "45 minutes",
    description: `
      Distance Reiki is a calming and supportive practice that works effectively even when we aren’t in the same space. Before the session, we’ll talk about your intentions or anything specific you’d like to focus on.

      When the session begins, you can relax in a comfortable spot at home while I connect with your energy from a distance. Using visualization and intention, I channel Reiki energy to you, helping to clear blockages, promote relaxation, and encourage your body’s natural healing process.

      Many people feel sensations like warmth, tingling, or a sense of calm during the session. Afterward, you can share your experience. It’s a powerful way to feel balanced and supported no matter where you are.
    `,
  },
];

const Services = () => {
  return (
    <div id="pricing" className="bg-gray-50 py-16 px-6 sm:px-12 lg:px-20 relative">
      {/* Header Section */}
      <div className="text-center mb-8">
        <h2 className="text-xl sm:text-2xl font-[20px] mb-4 font-bicyclete text-about-me-orange">
          Space for your well-being
        </h2>
      </div>

      <p className="section-intro">Two ways to pause, reconnect, and receive personalized care.</p>
      {/* Cards Section */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 justify-center">
        {services.map((service, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-lg max-w-md mx-auto flex flex-col p-6"
          >
            <h3 className="text-xl font-semibold text-gray-800 mb-2 text-center">
              {service.title}
            </h3>
            <p className="text-gray-600 mb-2 text-center">
              <span className="session-price">{service.price}</span>
            </p>
            <p className="text-gray-600 mb-4 text-center">
              {service.duration} · {index === 0 ? "Burlington, ON" : "From your own space"}
            </p>
            <p className="session-summary">{index === 0 ? "A calming, personalized session in a peaceful setting, with time to settle in and share your experience." : "A quiet moment of connection and care, wherever you feel most comfortable."}</p>
            <details className="session-details"><summary>What to expect</summary>
            {service.description
              .trim()
              .split("\n\n")
              .map((paragraph, idx) => (
                <p key={idx} className="text-sm sm:text-base mb-3 text-gray-600 font-karla text-justify leading-[27px]">
                  {paragraph}
                </p>
              ))}
            </details>
          </div>
        ))}
      </div>

      {/* Button Section */}
      <div className="mt-8">
        <CalendlyTextWidget />
      </div>
    </div>
  );
};

export default Services;